import { currentAttribution } from "@app/attribution.ts";
import type { Attribution } from "@shared/attribution.ts";

type EventName =
  | "app_open"
  | "round_start"
  | "guess_submitted"
  | "round_complete"
  | "share_click"
  | "result_page_view"
  | "pwa_install";

export interface ProductEvent {
  name: EventName;
  roundId?: string | null;
  position?: number | null;
  score?: number | null;
  channel?: "native" | "whatsapp" | "x" | "copy" | null;
  referrerShareId?: string | null;
  acq?: Attribution | null;
  ts?: number;
}

let queue: ProductEvent[] = [];
let disabled = false;

/** Modo captura: no se envía ningún evento. */
export function disableAnalytics(): void {
  disabled = true;
  queue = [];
  clearTimeout(timer);
}
let timer: ReturnType<typeof setTimeout> | undefined;

export function track(event: ProductEvent): void {
  if (disabled) return;
  const acq = event.name === "app_open" ? currentAttribution() : null;
  queue.push({ ...event, ...(acq ? { acq } : {}), ts: event.ts ?? Date.now() });
  if (queue.length >= 10) {
    void flush();
    return;
  }
  clearTimeout(timer);
  timer = setTimeout(() => void flush(), 2000);
}

export async function flush(): Promise<void> {
  if (queue.length === 0) return;
  const events = queue;
  queue = [];
  const payload = JSON.stringify({ events });
  const url = "/api/events";
  try {
    if (typeof navigator !== "undefined" && "sendBeacon" in navigator) {
      const blob = new Blob([payload], { type: "application/json" });
      navigator.sendBeacon(url, blob);
      return;
    }
  } catch {
    /* cae al fetch */
  }
  try {
    await fetch(url, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: payload,
      keepalive: true,
    });
  } catch {
    /* la analítica nunca debe romper el juego */
  }
}

export function installFlushOnHide(): void {
  if (typeof document === "undefined") return;
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") void flush();
  });
}
